@if (backgroundUrl$ | async; as url) {
<atx-image
  class="img-fluid"
  [imageUrl]="url"
  [maxWidth]="IMAGE_MAX_SIZES.XXLARGE"
  objectFit="cover"
  objectPosition="object-center"
>
</atx-image>
}
